import { TextInput, ToggleInput } from '@/shared/ui';
import useSetMaxMinHrModal from './useSetMaxMinHrModal';

export type SetMaxMinHrModalProps = {
  chartRef?: any;
  selectedPoint?: any;
  onCloseModal: () => void;
  timezoneOffset?: any;
};

/**
 * Form for overriding a day's minimum or maximum heart rate with a manually entered value. useSetMaxMinHrModal supplies the set-as options, the current selection, the formatted value and its validation error, while the footer buttons cancel the edit or commit the entered bpm value.
 *
 * @param props - Modal props identifying the reading being overridden and passed straight to the hook.
 * @returns The rendered set-as toggle, bpm value input and the cancel and set-value footer buttons.
 */
const SetMaxMinHrModal = ({
  chartRef,
  selectedPoint,
  onCloseModal,
  timezoneOffset,
}: SetMaxMinHrModalProps) => {
  const {
    setAsOptions,
    setAs,
    onChange,
    errorInput,
    generateValue,
    onChangeValueSetAs,
    onClickCancel,
    onClickSetValue,
  } = useSetMaxMinHrModal({ chartRef, selectedPoint, onCloseModal, timezoneOffset });

  return (
    <>
      <div className="set-min-max-hr-draggable-modal-content">
        <div className="hr-input-row">
          <div className="input-title">Set as</div>
          <ToggleInput
            className="input-list-item"
            name="setAs"
            options={setAsOptions}
            value={setAs}
            onChange={onChange}
          />
        </div>
        <div className="hr-input-row mt-3">
          <div className="input-title">Value</div>
          <TextInput
            name={undefined as any} // pre-existing bug: TextInput's `name` is required but never passed here
            isNumberFormat
            ariaLabel="Value"
            suffix="bpm"
            isError={!!errorInput}
            errorMessage={errorInput}
            value={generateValue()}
            onChange={onChangeValueSetAs}
            id="set-min-max-hr-value"
            decimalSeparator={false}
          />
        </div>
      </div>
      <div className="footer-btn">
        <button
          id="beatrh-cancel-set-min-max"
          className="draggable-modal-btn"
          onClick={onClickCancel}
        >
          Cancel
        </button>
        <button
          id="beatrh-set-min-max"
          className="draggable-modal-btn btn-main"
          onClick={onClickSetValue}
        >
          Set Value
        </button>
      </div>
    </>
  );
};

export default SetMaxMinHrModal;
